import { render, staticRenderFns } from "./TemplatePicker.vue?vue&type=template&id=c63fd104&scoped=true"
import script from "./TemplatePicker.vue?vue&type=script&lang=ts"
export * from "./TemplatePicker.vue?vue&type=script&lang=ts"
import style0 from "./TemplatePicker.vue?vue&type=style&index=0&id=c63fd104&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c63fd104",
  null
  
)

export default component.exports